import React, { useEffect, useMemo, useState } from "react";

import { useSFBComponents } from "hooks";
import { mapType } from "utils";

const DEFAULT_COMPONENT = ({ config }) => (
	<div>
		{`Simplified Form Builder cannot render type "${config.type}"`}
	</div>
);

const DebouncedComponent = ({ config, onChange, ...rest }) => {
	const [ localConfig, setLocalConfig ] = useState(config);
	const components = useSFBComponents();

	const Component = useMemo(
		() => components[mapType(config.type)] || DEFAULT_COMPONENT,
		[ components, config.type ],
	);

	useEffect(() => {
		const changeTimer = setTimeout(() => {
			if (JSON.stringify(localConfig) !== JSON.stringify(config)) {
				onChange(localConfig);
			}
		}, 300);

		return () => clearTimeout(changeTimer);
	}, [ config, localConfig, onChange ]);


	return (
		<Component
			{...rest}
			config={localConfig}
			onChange={setLocalConfig}
		/>
	);
};


export default DebouncedComponent;
